import { Component } from '@angular/core';
import { ApiService } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'ez-login',
    template: require('./lostpassword.component.html'),
    styles: [require('./lostpassword.component.less')]
})

export class LostPasswordComponent {
    public email: string = '';
    public errorMessage: string = '';
    public emailSent: boolean = false;
    public providerName: string = '';

    constructor(
        private apiService: ApiService,
        private translateService: TranslateService
    ) {}

    public send() {
        this.errorMessage = '';

        this.apiService.sendLostPasswordEmail(this.email, environment.channelId).subscribe((res) => {
            this.emailSent = res.sent;
            if (this.emailSent === false) {
                this.translateService.get('public.lostpassword.error').subscribe((str) => {
                    this.errorMessage = str.replace('%s', this.email);
                });
            } else {
                if (res.providerInformations.provName && res.providerInformations.provName !== '') {
                    this.providerName = res.providerInformations.provName;
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/login/lostpassword/lostpassword.component.ts